import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const LoadingScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/invoicepreview');
    }, 3000); // Redirect after 3 seconds

    return () => clearTimeout(timer); // Cleanup timer on unmount
  }, [navigate]);

  	return (
    		<div className="w-full relative [background:radial-gradient(50%_50%_at_50%_50%,_#c0efff,_#ebf2f5)] h-[1024px] overflow-hidden text-center text-[24px] text-neutrals-neutral-900 font-open-sans">
      			<div className="absolute top-[calc(50%_-_96px)] left-[calc(50%_-_174px)] flex flex-col items-center justify-start gap-6">
        				<div className="w-[100px] relative h-[100px]">
          					<div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-[50%] before:content-[''] before:absolute before:inset-[-3px] before:rounded-[50%] before:[background:conic-gradient(from_180deg_at_50%_50%,_#487c94_0deg,_rgba(72,_124,_148,_0)_360deg)] before:animate-[spin_2s_linear_infinite] after:content-[''] after:absolute after:inset-[3px] after:rounded-[50%] after:bg-[#ebf2f5]" />
          					<img className="absolute w-[40px] h-[40px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" alt="" src="assets/AI.svg" />
        				</div>
        				<div className="flex flex-col items-center justify-start gap-1.5">
          					<div className="relative font-semibold">Generating invoice</div>
          					<div className="relative text-xl text-neutrals-neutral-300 text-[16px]">Your invoice will be generated soon...</div>
        				</div>
      			</div>
    		</div>);
};

export default LoadingScreen;